import { useEffect, useRef } from 'react'
import { useQuery, useApolloClient } from '@apollo/client/react'
import { useLocalizedNavigate } from '@/hooks/useLocalizedPath'
import { useTranslation } from 'react-i18next'
import { GET_ACTIVE_CUSTOMER_QUERY } from '@/api/getActiveCustomer'
import { useAuthStore } from '@/store/authStore'

export default function SessionGuard() {
  const { t } = useTranslation()
  const navigate = useLocalizedNavigate()
  const client = useApolloClient()
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const token = useAuthStore((state) => state.token)
  const logout = useAuthStore((state) => state.logout)
  const handledRef = useRef(false)

  const { data, loading } = useQuery(GET_ACTIVE_CUSTOMER_QUERY, {
    skip: !isAuthenticated,
    fetchPolicy: 'cache-and-network',
  })

  useEffect(() => {
    if (!isAuthenticated || !token || loading || data === undefined) {
      return
    }

    if (data.activeCustomer != null) {
      handledRef.current = false
      return
    }

    if (handledRef.current) {
      return
    }

    handledRef.current = true

    async function handleInactiveSession() {
      logout() // clear user auth token
      await client.resetStore() // reset the Apollo Client cache
      window.alert(t('common.sessionInactive'))
      navigate('/login', { replace: true })
    }

    void handleInactiveSession()
  }, [isAuthenticated, token, loading, data, logout, client, navigate, t])

  return null
}
